
<template>
  
    <section class="bg-white p-10 mt-10 rounded-lg ">
        <div class="text-center mb-8">
            <h2 class="text-2xl font-bold">Notre partenaire de confiance</h2>
            <p class="text-gray-700 mt-2">Collaborer avec un leader du secteur pour vous offrir le meilleur service.</p>
        </div>
        <div class="flex justify-center items-center">
            <!-- Logo du partenaire -->
            <div class="text-center">
                <a href="http:///www.vmcomm1.com/" target="_blank" rel="noopener noreferrer"> <img src="../assets/images/vmcom.png" alt="Nom du Partenaire" class="mx-auto h-20 w-auto shadow-lg rounded"> </a>
            </div>
        </div>
    </section>

    <!-- Features Section End -->
</template>
